<form [formGroup]="conditionForm" (ngSubmit)="onClickSearch()">
  <mat-card class="cur-card" *ngIf="loadedCodeList">
    <mat-card-header>
      <mat-card-title>検索条件</mat-card-title>
      <mat-icon></mat-icon>
    </mat-card-header>
    <mat-card-content>
      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-form-field appearance="outline" class="input-form-select" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>受付拠点（会社）</mat-label>
          <mat-select
            formControlName="acceptbaseCompany"
            autocomplete="off"
            (ngModelChange)="changeAcceptbaseCompany()"
          >
            <mat-option value="" selected></mat-option>
            <mat-option
              *ngFor="let type of companyCodeList"
              [value]="type.value"
            >{{type.viewValue}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form-select" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>受付拠点（組織）</mat-label>
          <mat-select
            formControlName="acceptbaseSosiki"
            autocomplete="off">
            <mat-option value="" selected></mat-option>
            <mat-option
              *ngFor="let type of repbaseList"
              [value]="type.value"
            >{{type.viewValue}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-form-field appearance="outline" class="input-form-select" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>申込書種別</mat-label>
          <mat-select
            formControlName="srndocClsfy"
            autocomplete="off"
            required>
            <mat-option value="" selected></mat-option>
            <mat-option
              *ngFor="let type of srndocClsfyCodeList"
              [value]="type.value"
            >{{type.viewValue}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-form-field appearance="outline" class="input-form-date" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>受付日(From)</mat-label>
          <input matInput
            formControlName="aceptDateFrom"
            [matDatepicker]="aceptDateFrom"
          />
          <mat-datepicker-toggle matSuffix [for]="aceptDateFrom"></mat-datepicker-toggle>
          <mat-datepicker #aceptDateFrom [startAt]="aceptDateFromStDate"></mat-datepicker>
        </mat-form-field>
        <span style="margin-left: 40px">～</span>
        <mat-form-field appearance="outline" class="input-form-date" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>受付日(To)</mat-label>
          <input matInput
            formControlName="aceptDateTo"
            [matDatepicker]="aceptDateTo"
            required
          />
          <mat-datepicker-toggle matSuffix [for]="aceptDateTo"></mat-datepicker-toggle>
          <mat-datepicker #aceptDateTo [startAt]="aceptDateToStDate" ></mat-datepicker>
        </mat-form-field>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-form-field appearance="outline" class="input-form-select" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>申込書送付ステータス</mat-label>
          <mat-select
            formControlName="srndocDeliverySts"
            autocomplete="off">
            <mat-option value="" selected></mat-option>
            <mat-option
              *ngFor="let type of srndocDeliveryStatuscodeList"
              [value]="type.value"
            >{{type.viewValue}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div fxLayout="row wrap" fxLayoutAlign="end center">
        <mat-card-actions class="btn_area_right">
          <button type="submit" mat-raised-button
            color="primary"
            class="btn btnSearch"
            [disabled]="!conditionForm.valid"
          >検索</button>
        </mat-card-actions>
        <mat-card-actions class="btn_area_right">
          <button type="button" mat-raised-button
            color="primary"
            class="btn btnClear"
            [disabled]="disabledCleaerButton()"
            (click)="onClickClear()"
          >クリア</button>
        </mat-card-actions>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="end center">
        <mat-card-actions class="btn_area_right">
          <button type="button" mat-raised-button
            color="primary"
            class="btn btnPrev"
            (click)="goToPrevious()"
          >戻る</button>
        </mat-card-actions>
      </div>
    </mat-card-content>
  </mat-card>
</form>
    

